import styled from 'styled-components';
import { CarouselItem, CarouselControl } from 'reactstrap';
import { FaArrowLeft } from 'react-icons/fa';

export const DivMontante = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

export const DivView = styled.div`
	display: flex;
	width: 100%;
	/* padding: 0 20% 0 20%; */
	flex-direction: row;
	align-items: center;
	justify-content: center;
`;

export const ImgMontante = styled.img`
	filter: brightness(0);
`;

export const CarouselItemStyle = styled(CarouselItem)`
	max-width: 100%;
	height: 170px;
	box-shadow: none !important;
`;

export const TextMontante = styled.div``;

export const PrevButton = styled(CarouselControl)`
`;

export const CustomPrevIcon = styled(FaArrowLeft)`
  font-size: 24px;
`;

